import React from "react";
import { Flex, Box } from "rebass";

export default ({ items, columns, spacing, mb, ...rest }) => {
  const viewItems = items.map((item, i) => {
    return (
      <Box w={1 / (columns || 4)} p={spacing} mb={mb} key={i}>
        {item}
      </Box>
    );
  });

  return (
    <Flex w="100%" wrap {...rest}>
      {viewItems}
    </Flex>
  );
};



// WEBPACK FOOTER //
// ./src/components/grid.js